import Vue from 'vue'
import store from './../store'
import io from 'socket.io-client'
import logger from './../helpers/logger.helper'
import DeferredPromise from './../helpers/deferredPromise.helper'
import Chat from './socket/chat'

let _chatConnections = []
let _chats = {}
let _reconnectCallbacks = []
let _disconnectedCallbacks = []
let _notificationCallbacks = []

class SocketService {
  constructor () {
    console.log('cons')
  }

  init () {
    this._socket = new Promise((resolve, reject) => {
      store.dispatch('getAuthHeader')
        .then(headers => {
          const socket = io(Vue.config.env.VUE_APP_SOCKET_URL + ':' + (Vue.config.env.VUE_APP_SOCKET_PORT || 3000), {
            query: {
              headers: JSON.stringify(headers)
            }
          })

          socket.on('connect', SocketService.onConnect)
          socket.on('disconnect', SocketService.onDisconnect)
          socket.on('chat-entered', SocketService.onChatEntered)
          socket.on('chat-message', SocketService.onChatMessage)
          socket.on('notification', SocketService.onNotification)
          resolve(socket)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  disconnectedCallback (cb) {
    _disconnectedCallbacks.push(cb)
  }

  reconnectedCallback (cb) {
    _reconnectCallbacks.push(cb)
  }

  notificationCallback (cb) {
    _notificationCallbacks.push(cb)
  }

  static onConnect () {
    logger.log('connected')
    _reconnectCallbacks.forEach(cb => {
      cb()
    })
  }

  static onDisconnect () {
    logger.log('disconnected')
    _disconnectedCallbacks.forEach(cb => {
      cb()
    })
  }

  enterChat (chatId) {
    logger.log('enter-chat', chatId)
    this._socket.then(socket => {
      socket.emit('enter-chat', chatId)
    })

    _chatConnections[chatId] = new DeferredPromise()
    return _chatConnections[chatId].promise()
  }

  leaveChat (chatId) {
    delete _chatConnections[chatId]
    delete _chats[chatId]
    this._socket.then(socket => {
      socket.emit('leave-chat', chatId)
    })
  }

  static onChatEntered (chatId) {
    logger.log('chat-entered', chatId)
    console.log(_chatConnections[chatId])
    _chats[chatId] = new Chat(chatId)
    _chatConnections[chatId].resolve(_chats[chatId])
  }

  static onChatMessage (chatId, message) {
    logger.log('chat-message', chatId, message)
    _chats[chatId].message(message)
  }

  static onNotification (notification) {
    logger.log('notification', notification)
    _notificationCallbacks.forEach(cb => {
      cb(notification)
    })
  }
}

export default SocketService
